// Collection of short animations that add flair or improve UX
// Pairs with the .scss file of the same name.
// If you wanna do long or complicated animations, please do them elsewhere.

// Do a short and small shake left-right on the screen. Useful for drawing
// attention to elements on the screen, such as an input with failing
// validations or a message that needs responding to.
export function shakeToDrawAttention(options: ShakeHeadOptions) {
  const element = options.element;

  element.classList.add(SHAKE_HEAD_CLASS);

  const runningTimeoutID = element.dataset[SHAKE_HEAD_DATASET_NAME_TIMEOUT_ID];
  if (runningTimeoutID) {
    clearTimeout(parseInt(runningTimeoutID));
  }

  const timeoutID = setTimeout(() => {
    element.classList.remove(SHAKE_HEAD_CLASS);
  }, SHAKE_DURATION);

  element.dataset[SHAKE_HEAD_DATASET_NAME_TIMEOUT_ID] =
    timeoutID as unknown as string;
}

const SHAKE_HEAD_DATASET_NAME_TIMEOUT_ID = `elementAnimatorShakeHeadTimeoutId`;
const SHAKE_HEAD_CLASS = `element-animator-draw-attention-shake`;
const SHAKE_DURATION = 400;

type ShakeHeadOptions = {
  element: HTMLElement,
  cb?: () => void,
};

export function showInstantlyFadeOutAction(element: HTMLElement) {
  showInstantlyFadeOut({element});
}

export function showInstantlyFadeOutCancel(element: HTMLElement) {
  element.style.transition = ``;
  element.style.opacity = `1`;

  const runningTimeoutID =
    element.dataset[SHOW_INSTANTLY_FADEOUT_DATASET_NAME_TIMEOUT_ID];
  if (runningTimeoutID) {
    clearTimeout(parseInt(runningTimeoutID));
  }
}

// Show the element instantly by setting opacity to 1. Then wait delay (ms).
// Then start fading the element out using transition for duration (ms).
// Useful for showing a small message like "Saved" right next to the thing
// the user just clicked, without being too annoying about it.
export function showInstantlyFadeOut(options: ShowInstantlyFadeOutOptions) {
  const element = options.element;
  const delay = options.delay || SHOW_INSTANTLY_FADEOUT_DEFAULT_DELAY;
  const duration = options.duration || SHOW_INSTANTLY_FADEOUT_DEFAULT_DURATION;

  showInstantlyFadeOutCancel(element);

  const timeoutID = setTimeout(() => {
    element.style.transition = `opacity ${duration}ms`;
    element.style.opacity = `0`;
  }, delay);

  element.dataset[SHOW_INSTANTLY_FADEOUT_DATASET_NAME_TIMEOUT_ID] =
    timeoutID as unknown as string;
}

const SHOW_INSTANTLY_FADEOUT_DATASET_NAME_TIMEOUT_ID =
  `elementAnimatorSifoTimeoutId`;
const SHOW_INSTANTLY_FADEOUT_DEFAULT_DELAY = 1200;
const SHOW_INSTANTLY_FADEOUT_DEFAULT_DURATION = 1000;

type ShowInstantlyFadeOutOptions = {
  element: HTMLElement,
  delay?: number,
  duration?: number,
};
